__turbopack_context__.v({
  "text-area": "GuideTextArea-module-scss-module__1nW7rG__text-area",
  "text-area__isCard": "GuideTextArea-module-scss-module__1nW7rG__text-area__isCard",
});
